import React, { ComponentProps, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  TextFieldProps, TextField
} from '@material-ui/core';

import DialogTitle from './DialogTitle';

export interface PromptDialogProps {
  title: string
  message: ComponentProps<any>['children']
  submitText: string
  cancelText: string
  fieldProps: Omit<TextFieldProps, 'value' | 'onChange'>,
  callback: (value: string|null) => void
}

const PromptDialog = (props: PromptDialogProps) => {
  const [value, setValue] = useState<string>('');

  return (
    <Dialog open={true} onClose={() => props.callback(null)} fullWidth={true}>
      <form onSubmit={() => props.callback(value)}>
        <DialogTitle onClose={() => props.callback(null)}>{props.title}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {props.message}
          </DialogContentText>
          <TextField value={value} onChange={e => setValue(e.target.value)} {...props.fieldProps} />
        </DialogContent>
        <DialogActions>
          <Button type="button" onClick={() => props.callback(null)} color="primary">
            {props.cancelText}
          </Button>
          <Button type="submit" color="primary" autoFocus>
            {props.submitText}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default PromptDialog;